import store from 'store'
import expirePlugin from 'store/plugins/expire'

// init storejs
store.addPlugin(expirePlugin)

export default {
  prefix: '',

  /**
   * set data to storage
   * @param key
   * @param value
   * @param expire
   */
  set(key: string, value: string, expire = 0) {
    // @ts-ignore
    if (expire > 0) {
      store.set(this.prefix + key, value, new Date().getTime() + expire * 1000)
    } else {
      store.set(this.prefix + key, value)
    }
  },

  /**
   * get data from storage
   * @param key
   */
  get(key: string) {
    return store.get(this.prefix + key) ?? ''
  },

  /**
   * remove data from storage
   * @param key
   */
  remove(key: string) {
    store.remove(this.prefix + key)
  },

  /**
   * get storage by prefix
   * @param prefix
   */
  getByPrefix(prefix: string) {
    const keys: string[] = []

    store.each((value: string, key: string) => {
      if (key && key.indexOf(this.prefix + prefix) === 0) {
        keys.push(key)
      }
    })

    return keys
  },

  /**
   * remove by prefix
   * @param {string} prefix
   */
  removeByPrefix(prefix) {
    const keys = this.getByPrefix(prefix)

    if (Array.isArray(keys) && keys.length) {
      keys.forEach((key) => this.remove(key))
    }
  },
}
